/**
 * @generated SignedSource<<8702157aac96403250495f9a4fa778e3>>
 * @relayHash ca857c93c0d80ce9567ee261446bcd4b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ca857c93c0d80ce9567ee261446bcd4b

import { ConcreteRequest } from 'relay-runtime';
export type De_createOrUpdatePatientBodyMeasurementInput = {
  date: any;
  height?: number | null;
  patientId: string;
  weight: number;
};
export type deCreateOrUpdatePatientBodyMeasurementMutation$variables = {
  connections: ReadonlyArray<string>;
  input: De_createOrUpdatePatientBodyMeasurementInput;
};
export type deCreateOrUpdatePatientBodyMeasurementMutation$data = {
  readonly createOrUpdatePatientBodyMeasurement: {
    readonly bodyMeasurement: {
      readonly bodyMassIndex: number | null;
      readonly date: any;
      readonly height: number | null;
      readonly id: string;
      readonly weight: number;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly patientId?: string;
    }> | null;
  };
};
export type deCreateOrUpdatePatientBodyMeasurementMutation = {
  response: deCreateOrUpdatePatientBodyMeasurementMutation$data;
  variables: deCreateOrUpdatePatientBodyMeasurementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = [
  (v3/*:: as any*/)
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*:: as any*/),
  "type": "Error",
  "abstractKey": "__isError"
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*:: as any*/),
  "type": "InvalidWeight",
  "abstractKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v4/*:: as any*/),
  "type": "InvalidHeight",
  "abstractKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    (v3/*:: as any*/)
  ],
  "type": "PatientNotFound",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "BodyMeasurement",
  "kind": "LinkedField",
  "name": "bodyMeasurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bodyMassIndex",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deCreateOrUpdatePatientBodyMeasurementMutation",
    "selections": [
      {
        "alias": "createOrUpdatePatientBodyMeasurement",
        "args": (v2/*:: as any*/),
        "concreteType": "De_createOrUpdatePatientBodyMeasurementPayload",
        "kind": "LinkedField",
        "name": "de_createOrUpdatePatientBodyMeasurement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v9/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deCreateOrUpdatePatientBodyMeasurementMutation",
    "selections": [
      {
        "alias": "createOrUpdatePatientBodyMeasurement",
        "args": (v2/*:: as any*/),
        "concreteType": "De_createOrUpdatePatientBodyMeasurementPayload",
        "kind": "LinkedField",
        "name": "de_createOrUpdatePatientBodyMeasurement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v9/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "bodyMeasurement",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "BodyMeasurementsEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ca857c93c0d80ce9567ee261446bcd4b",
    "metadata": {},
    "name": "deCreateOrUpdatePatientBodyMeasurementMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1ce33871499ed8c5fc1d3ac24619895e";

export default node;
